module.exports = __webpack_public_path__ + "img/img_market_con2.be8bb78a.png";